module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ambis-meter"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Ambis Meter',
          to: {
            path: '/ambis-meter'
          },
        },
        {
          text: 'Leaderboard'
        } ],
      "divider": ">"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Leaderboard")]), _vm._v(" "), _c('v-card', [_c('v-list-item', {
    staticClass: "mx-5 my-5",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Kelas\n                ")]), _vm._v(" "), _c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "outlined": "",
      "placeholder": "Pilih Kelas",
      "items": _vm.listClass,
      "item-text": "name",
      "item-value": "id"
    },
    on: {
      "change": _vm.fetchData
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-item', {
          staticClass: "pa-0 ma-0"
        }, [_c('v-list-item-title', [_vm._v(_vm._s(item.name))])], 1)]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-item-title', [_vm._v(_vm._s(item.name))])]
      }
    }]),
    model: {
      value: (_vm.kelas),
      callback: function($$v) {
        _vm.kelas = $$v
      },
      expression: "kelas"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.isShow) ? _c('v-card', [_c('v-card-title', [_vm._v(" Periode " + _vm._s(_vm.periode_name) + " ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('app-datatable', {
    key: _vm.tableKey,
    attrs: {
      "items": _vm.ranks,
      "headers": _vm.headers,
      "custom-pagination-per-page": 100,
      "custom-pagination-total-items": _vm.ranks.length,
      "custom-pagination-current-page": 1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71dfce7b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_meter/components/Leaderboard.vue
// module id = 975
// module chunks = 1